export class productGrdSearchFields {

  Name: string;
  PageNo: number;
  PageSize: number;
}

export class TestMethodModel {
  TestMethodId: number;
  Name: string;
  TestMethodCode: string;
  Description: string;
  UnitId: number;

  PageNo: number;
  PageSize: number;

}
export class OilGradeModel {
  OilGradeId: number;
  Name: string;
  Description: string;
  AliasName: string;
  LstOilGradeChars: OilGradeCharModel[];
}

export class OilGradeCharModel {
  CharacteristicId: number;
  Name: string;
  LubCharValueTypeId: number;
  Value1: string;
  Value2: string;

}

export class AnalysisSectionSearchModel {
  AnalysisElementSectionTypeId: number;
  Name: string;
  CustomerId: number;
  SampleTypeId:number;
  PageNo: number;
  PageSize: number;
}

export class AnalysisSectionModel{
  CharacteristicId:number;
  name:string;

}